// extracted by mini-css-extract-plugin
export default {"rating":"Rating_rating__n9Ftx","idle":"Rating_idle__ffjuz","yippee":"Rating_yippee__P3aXD"};